module.exports = __webpack_public_path__ + "20250721160708/img/key_point.57433fa3.png";